import { Injector } from '@angular/core';
import {
  EIremboFormlyFieldSubTypes,
  EIremboFormlyFieldTypes,
} from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  getDefaultBaseSettingsConfigFormly,
  generateDataFetchDataSettingsConfig,
  generateDatasetSettingsConfig,
  generateGenericLabelValueSettingsContentConfig,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  customDropDownFieldParseIntoSettingsFormModel,
  defaultCustomDropDownConfigFormModel,
} from '../custom-dropdown-field-type.configuration';
import {
  customDropDownWithDataFetchFieldParseIntoSettingsFormModel,
  customDropDownWithDataFetchFieldUpdateFromSettingsFormModel,
  defaultCustomDropDownWithDataFetchConfigFormModel,
} from '../custom-dropdown-with-data-fetch-field-type.configuration';
import {
  customDropDownWithDatasetFieldParseIntoSettingsFormModel,
  customDropDownWithDatasetFieldUpdateFromSettingsFormModel,
  defaultCustomDropDownWithDataSetConfigFormModel,
} from '../custom-dropdown-with-dataset-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomDropdownPaginatedFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  subType!: EIremboFormlyFieldSubTypes;

  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);
    this.subType = field.props?.['subType'];
    this.setSettings();
  }

  override parseFieldConfigIntoSettingsFormModel() {
    if (
      this.subType ===
      EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH_PAGINATED
    ) {
      return customDropDownWithDataFetchFieldParseIntoSettingsFormModel(
        this.field
      );
    }

    if (
      this.subType ===
      EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET_PAGINATED
    ) {
      return customDropDownWithDatasetFieldParseIntoSettingsFormModel(
        this.field
      );
    }

    return customDropDownFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    if (
      this.subType ===
      EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH_PAGINATED
    ) {
      return customDropDownWithDataFetchFieldUpdateFromSettingsFormModel(
        model,
        this.field
      );
    }

    if (
      this.subType ===
      EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET_PAGINATED
    ) {
      return customDropDownWithDatasetFieldUpdateFromSettingsFormModel(
        model,
        this.field
      );
    }

    return customDropDownWithDatasetFieldUpdateFromSettingsFormModel(
      model,
      this.field
    );
  }

  private setSettings() {
    switch (this.subType) {
      case EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH_PAGINATED:
        this.settingsFormlyModel =
          defaultCustomDropDownWithDataFetchConfigFormModel;
        this.settingsFormlyForm = [
          ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
          {
            key: 'disabled',
            type: EIremboFormlyFieldTypes.checkbox,
            props: {
              label: 'Disabled',
              hideHeader: true,
              placeholder: 'Disabled',
              required: false,
              formCheck: 'switch',
            },
            id: 'disabled',
          },
          generateDataFetchDataSettingsConfig(),
        ];
        break;

      case EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET_PAGINATED:
        this.settingsFormlyModel =
          defaultCustomDropDownWithDataSetConfigFormModel;
        this.settingsFormlyForm = [
          ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
          {
            key: 'readonly',
            type: EIremboFormlyFieldTypes.checkbox,
            props: {
              label: 'Read Only',
              hideHeader: true,
              placeholder: 'Read Only',
              required: false,
              formCheck: 'switch',
            },
            id: 'readonly',
          },
          {
            key: 'disabled',
            type: EIremboFormlyFieldTypes.checkbox,
            props: {
              label: 'Disabled',
              hideHeader: true,
              placeholder: 'Disabled',
              required: false,
              formCheck: 'switch',
            },
            id: 'disabled',
          },
          generateDatasetSettingsConfig(),
        ];
        break;

      default:
        this.settingsFormlyModel = defaultCustomDropDownConfigFormModel;
        this.settingsFormlyForm = [
          ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
          {
            key: 'disabled',
            type: EIremboFormlyFieldTypes.checkbox,
            props: {
              label: 'Disabled',
              hideHeader: true,
              placeholder: 'Disabled',
              required: false,
              formCheck: 'switch',
            },
            id: 'disabled',
          },
          generateGenericLabelValueSettingsContentConfig(
            'Dropdown Options',
            true
          ),
        ];
        break;
    }
  }
}
